export const FETCH_TAX_EXPENSE_REPORT = 'FETCH_TAX_EXPENSE_REPORT';
export const FETCHING_TAX_EXPENSE_REPORT_SUCCESS = 'FETCHING_TAX_EXPENSE_REPORT_SUCCESS';
export const SELECT_VIEW_TYPE = 'SELECT_VIEW_TYPE';
export const SELECT_REPORT_BOOK_TYPE = 'SELECT_REPORT_BOOK_TYPE';
export const SELECT_REPORT_BOOK_TYPES = 'SELECT_REPORT_BOOK_TYPES';
export const SELECT_GROUP_TYPE = 'SELECT_GROUP_TYPE';
export const FETCH_TAX_EXPENSE_REPORT_FOR_ALL_PILLS = 'FETCH_TAX_EXPENSE_REPORT_FOR_ALL_PILLS';
export const FETCH_TAX_EXPENSE_REPORT_FOR_ALL_PILLS_SUCCESS = 'FETCH_TAX_EXPENSE_REPORT_FOR_ALL_PILLS_SUCCESS';
export const FETCH_TAX_EXPENSE_REPORT_FOR_ALL_PILLS_FAILURE = 'FETCH_TAX_EXPENSE_REPORT_FOR_ALL_PILLS_FAILURE';
export const FETCH_DRILL_DETAIL = 'FETCH_DRILL_DETAIL';
export const FETCH_DRILL_DETAIL_SUCCESS = 'FETCH_DRILL_DETAIL_SUCCESS';
export const FETCH_DRILL_DETAIL_FAILURE = 'FETCH_DRILL_DETAIL_FAILURE';
export const SELECT_ENTRY_FOR_DRILL_DETAIL = 'SELECT_ENTRY_FOR_DRILL_DETAIL';
export const SELECT_COMPANY_CODE_TO_FILTER = 'SELECT_COMPANY_CODE_TO_FILTER';
export const SELECT_CUSTOM_GROUP = 'SELECT_CUSTOM_GROUP';
export const SELECT_DETAIL_AGGREGATION_TYPE = 'SELECT_DETAIL_AGGREGATION_TYPE';
export const RESET_TAX_EXPENSE_REPORT = 'RESET_TAX_EXPENSE_REPORT';

export const FETCH_COUNTRY_TAX_TYPES = 'FETCH_COUNTRY_TAX_TYPES_FOR_TAX_EXPENSE_REPORT';
export const FETCH_COUNTRY_TAX_TYPES_SUCCESS = 'FETCH_COUNTRY_TAX_TYPES_FOR_TAX_EXPENSE_REPORT_SUCCESS';
export const FETCH_COUNTRY_TAX_TYPES_FAILURE = 'FETCH_COUNTRY_TAX_TYPES_FOR_TAX_EXPENSE_REPORT_FAILURE';

export const SELECT_COUNTRY_TAX_TYPE = 'SELECT_COUNTRY_TAX_TYPE';
